module.exports = __webpack_public_path__ + "img/chain_sale02.edd0499f.png";